var map = {
	"./pt-BR/address.json": [
		62508,
		2508
	],
	"./pt-BR/affiliates.json": [
		28827,
		8827
	],
	"./pt-BR/appointments.json": [
		75622,
		5622
	],
	"./pt-BR/auth.json": [
		93964,
		3964
	],
	"./pt-BR/balances.json": [
		42148,
		2148
	],
	"./pt-BR/banks.json": [
		39929,
		9929
	],
	"./pt-BR/calendar.json": [
		76803,
		6803
	],
	"./pt-BR/common.json": [
		99625,
		9625
	],
	"./pt-BR/companies.json": [
		421,
		421
	],
	"./pt-BR/configurations.json": [
		46314,
		6314
	],
	"./pt-BR/horses.json": [
		8347,
		8347
	],
	"./pt-BR/invites.json": [
		88097,
		8097
	],
	"./pt-BR/menu.json": [
		47674,
		7674
	],
	"./pt-BR/messages.json": [
		20221,
		221
	],
	"./pt-BR/modalities.json": [
		95260,
		5260
	],
	"./pt-BR/myTeam.json": [
		12388,
		2388
	],
	"./pt-BR/notifications.json": [
		4530,
		4530
	],
	"./pt-BR/plans.json": [
		48848,
		8848
	],
	"./pt-BR/profile.json": [
		46773,
		6773
	],
	"./pt-BR/riders.json": [
		40729,
		729
	],
	"./pt-BR/routes.json": [
		88393,
		8393
	],
	"./pt-BR/validations.json": [
		68823,
		8823
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 38140;
module.exports = webpackAsyncContext;